export const AUTH_FAILED_TEXT = 'Пользователь не авторизован';
export const AUTH_BY_CODE_ERROR = 'Ошибка авторизации code';
export const AUTH_BY_TRACK_ERROR = 'Ошибка авторизации trackId';
export const AUTH_SILENT_ERRORS = [AUTH_BY_CODE_ERROR, AUTH_BY_TRACK_ERROR];
